import Box from '@mui/material/Box';

import { CardInformation } from 'reservations/payments/components/CardInformation';
import { ExpiredPayment } from 'reservations/payments/components/ExpiredPayment';

type Props = {
  cardType: string;
  cardLast4: string;
  cardExpMonth: number;
  cardExpYear: number;
  isExpirationValid: boolean;
};

export const SavedPaymentMethodLabel = ({
  isExpirationValid,
  ...rest
}: Props) => (
  <Box display="flex" flexDirection="row" alignItems="center">
    <CardInformation {...rest} isExpirationValid={isExpirationValid} />
    <ExpiredPayment isExpirationValid={isExpirationValid} />
  </Box>
);
